import { Component, OnInit, ViewChild } from '@angular/core';
import { ItemIdMappingsFormComponent } from '../item-id-mappings-form/item-id-mappings-form.component';
import {UserService} from '@emm/core/services/user.service';


@Component({
    selector: 'emm-item-id-mappings',
    styleUrls: ['./item-id-mappings.component.scss'],
    templateUrl: './item-id-mappings.component.html',
    standalone: false
})
export class ItemIdMappingsComponent implements OnInit {

    @ViewChild(ItemIdMappingsFormComponent) itemIdMappingsForm: ItemIdMappingsFormComponent;
    isReadOnly = this.userService.hasLoginRole();
    isSuperAdmin = this.userService.hasSuperAdminRole();
    isAdmin = this.userService.hasAdminRole();
    isAuthor = this.userService.hasAuthorRole();

    constructor(private userService: UserService) {}


    ngOnInit(): void {}
}
